import {registerModule, Module} from './modules';
import {homeModule} from './views/home/homeView';
import {ModuleManagerModule} from 'views/admin/ModuleManager';
import {NewPropertySettingsModule, PropertySettingsModule} from 'propertySettings';
import StoryBulkEditModule from 'storyBulkEdit/';
import MediaSearchModule from './MediaSearch';
import HelpDeskModule from './helpDesk';

export const registerModules = (): Promise<Module[]> =>
    Promise.all([
        MediaSearchModule,
        NewPropertySettingsModule,
        PropertySettingsModule,
        ModuleManagerModule,
        homeModule,
        StoryBulkEditModule,
        HelpDeskModule,
    ].map(m =>
        // can't eliminate the lambda as registerModule has optional arguments
        registerModule(m)
    ));
